import { onMounted, onUnmounted } from 'vue';

import { guestSyncChannel, type GuestSyncMessage } from '@/api/guest/guestSyncChannel';
import { useGuestDataStore } from '@/stores/guestDataStore/guestDataStore';

interface UseGuestSyncOptions {
  onExternalUpdate: () => void | Promise<void>;
}

export const useGuestSync = (options: UseGuestSyncOptions): void => {
  const guestDataStore = useGuestDataStore();
  let unsubscribe: (() => void) | undefined;

  const handleSyncMessage = (message: GuestSyncMessage): void => {
    if (message.type === 'guests-updated') {
      const isSameVersion =
        message.version === guestDataStore.getVersion && message.updatedAt === guestDataStore.getUpdatedAt;

      if (!isSameVersion) {
        void options.onExternalUpdate();
      }

      return;
    }

    if (message.type === 'reload-request') {
      void options.onExternalUpdate();
    }
  };

  onMounted(() => {
    unsubscribe = guestSyncChannel.subscribe(handleSyncMessage);
  });

  onUnmounted(() => {
    unsubscribe?.();
  });
};
